var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFire(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.036.287a.75.75 0 0 1 .446.6c.29 2.463 1.495 3.638 2.812 4.922l.082.08c.672.656 1.397 1.376 1.941 2.308.556.952.906 2.094.906 3.591 0 1.392-.487 2.913-1.74 4.082-1.253 1.168-3.185 1.905-5.926 1.905-6.34 0-8.94-7.216-4.738-10.983a.75.75 0 0 1 1.24.682c-.166 1.003.01 1.647.268 2.04a1.56 1.56 0 0 0 1.07.688c.434.072.87-.023 1.178-.229.29-.193.472-.481.472-.883 0-.8-.115-1.553-.253-2.294l-.098-.507c-.11-.561-.223-1.136-.277-1.677-.073-.723-.053-1.474.23-2.215.288-.75.817-1.419 1.644-2.027a.75.75 0 0 1 .743-.083ZM9.268 6.52c.144.77.28 1.63.28 2.57a2.51 2.51 0 0 1-1.141 2.131c-.65.434-1.477.59-2.257.46a3.059 3.059 0 0 1-2.079-1.346 3.355 3.355 0 0 1-.397-.856c-1.285 2.908.664 6.796 4.883 6.796 2.477 0 4.002-.662 4.903-1.502.9-.84 1.263-1.938 1.263-2.985 0-1.241-.284-2.12-.701-2.835-.429-.734-1.014-1.326-1.694-1.99l-.117-.114c-1.099-1.07-2.339-2.279-2.936-4.356a2.33 2.33 0 0 0-.224.44c-.168.439-.2.93-.14 1.53.047.464.14.941.247 1.485.035.183.073.373.11.572Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "accent",
    fillRule: "evenodd",
    d: "M12.552 10.698a.75.75 0 0 1 .75.75c0 .831-.291 1.75-1.05 2.457-.757.707-1.894 1.122-3.435 1.122a.75.75 0 0 1 0-1.5c1.277 0 2.007-.34 2.413-.719.405-.378.572-.873.572-1.36a.75.75 0 0 1 .75-.75Z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.0f3400263a38e0448b82407be3fd6708.svg";
export { ForwardRef as ReactComponent };